export default __webpack_public_path__ + "static/media/ENFJ.4d401e04.svg";